import { useReduxState } from 'hooks';
import { Avatar } from 'components/common';

import type { AvatarProps } from 'components/common/Avatar';
import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  align?: string;
  color?: string;
  horizontal?: boolean;
  icon?: IconProp;
  iconProps?: AvatarProps;
  iconStyle?: React.CSSProperties;
  inline?: boolean;
  label: React.ReactNode;
  labelBefore?: boolean;
  labelStyle?: React.CSSProperties;
  small?: boolean;
  style?: React.CSSProperties;
  value: React.ReactNode;
  valueStyle?: React.CSSProperties;
}

const StatItem = ({
  align = 'center',
  color,
  horizontal = false,
  icon,
  iconProps,
  iconStyle,
  inline = false,
  label,
  labelBefore,
  labelStyle,
  small = false,
  style,
  value,
  valueStyle
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="stat" style={style}>
      {icon ? (
        <div className="icon" style={iconStyle}>
          <Avatar
            backgroundColor={theme.lightGrey}
            icon={icon}
            padding="10px 0"
            size="36px"
            {...iconProps}
          />
        </div>
      ) : null}

      <div className="content">
        {labelBefore ? (
          <div className="label" style={labelStyle}>
            {label}
          </div>
        ) : null}

        <div className="value" style={valueStyle}>
          {value}
        </div>

        {!labelBefore ? (
          <div className="label" style={labelStyle}>
            {label}
          </div>
        ) : null}
      </div>

      <style jsx>{`
        .stat {
          align-items: center;
          display: flex;
        }
        .icon {
          margin-right: 15px;
        }
        .content {
          display: ${inline ? 'inline-block' : 'block'};
          white-space: ${horizontal ? 'nowrap' : 'normal'};
          text-align: ${align};
        }
        .value {
          color: ${color || theme.textColorLight};
          font-size: ${small ? '2rem' : '2.6rem'};
          font-weight: 700;
          line-height: 1.1;
          margin-right: ${horizontal ? '7px' : '0'};
        }
        .label {
          color: ${color || theme.textColorLighter};
          font-size: ${small ? '1.3rem' : '1.4rem'};
          font-weight: 600;
        }
        .value,
        .label {
          display: ${horizontal ? 'inline-block' : 'block'};
        }
      `}</style>
    </div>
  );
};

export default StatItem;
